import { getAffiliateNetworksApiRequest } from '@/services/api/affiliate-networks-api';
import { useStore } from '@/store';

export const populateAffiliateNetworksStoreCacheApiRequest = async () => {
  const store = useStore();
  const payload = await getAffiliateNetworksApiRequest();
  store.cache.populateAffiliateNetworksCache(payload);
  return payload;
};
